"use client"

import { useState, useEffect } from "react"
import "./NicknameModal.css"

const NicknameModal = ({ isOpen, currentNickname, onSave, onClose }) => {
  const [nickname, setNickname] = useState(currentNickname)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setNickname(currentNickname)
  }, [currentNickname])

  const handleSave = async () => {
    if (!nickname.trim()) return

    setIsLoading(true)
    try {
      await onSave(nickname.trim())
      onClose()
    } catch (error) {
      console.error("Failed to save nickname:", error)
      alert("Failed to save nickname. Please try again.")
    } finally {
      setIsLoading(false)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave()
    } else if (e.key === "Escape") {
      onClose()
    }
  }

  if (!isOpen) return null

  return (
    <div className="nickname-modal-overlay">
      <div className="nickname-modal">
        <div className="nickname-modal-header">
          <h3>Set Your Nickname</h3>
          <button onClick={onClose} className="close-btn">
            ✕
          </button>
        </div>

        <div className="nickname-modal-content">
          <p>Choose a nickname so others can see who voted for what!</p>

          <input
            type="text"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            onKeyDown={handleKeyPress}
            placeholder="Enter your nickname..."
            maxLength={50}
            className="nickname-input"
            autoFocus
          />

          <div className="nickname-modal-actions">
            <button onClick={handleSave} disabled={!nickname.trim() || isLoading} className="save-btn">
              {isLoading ? "Saving..." : "Save Nickname"}
            </button>
            <button onClick={onClose} className="cancel-btn">
              Skip for now
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NicknameModal
